import { StyleSheet, css } from 'aphrodite'
import React from 'react'

interface TitleBlurbSectionProps {
  title: string
  description: string
  backgroundColor?: string
}

export default function TitleBlurbSection({
  title,
  description,
  backgroundColor = '#ffffff',
}: TitleBlurbSectionProps) {
  return (
    <section className={css(styles.section)} style={{ backgroundColor }}>
      <h2 className={css(styles.title)}>{title}</h2>
      <p className={css(styles.description)}>{description}</p>
    </section>
  )
}

const styles = StyleSheet.create({
  section: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    minHeight: '30vh',
    '@media (min-width: 768px)': {
      padding: '48px 2rem',
      minHeight: '35vh',
    },
    '@media (min-width: 1024px)': {
      marginTop: '-5rem',
      minHeight: '40vh',
    },
  },
  title: {
    fontFamily: '"Anton", sans-serif',
    fontSize: '32px',
    fontWeight: 400,
    color: '#1F3D61',
    marginBottom: '16px',
    lineHeight: 1.2,
    '@media (min-width: 768px)': {
      fontSize: '48px',
    },
    '@media (min-width: 1024px)': {
      fontSize: '60px',
    },
  },
  description: {
    fontSize: '14px',
    lineHeight: 1.5,
    color: '#4B5563',
    maxWidth: '100%',
    fontWeight: 400,
    '@media (min-width: 768px)': {
      fontSize: '16px',
      maxWidth: '600px',
    },
    '@media (min-width: 1024px)': {
      fontSize: '18px',
      maxWidth: '800px',
    },
  },
})
